import { api } from './_httpClient'

const list = async () => api.get('/user/list')

const create = async payload => api.post('/user', payload)

const update = async payload => api.put('/user', payload)

const deleteU = async payload => api.delete('/user', { params: payload })

export { list, create, update, deleteU }
